import React, { useState } from 'react';
import { Card, CardContent, Typography, CardActions, makeStyles, CircularProgress, CardHeader } from '@material-ui/core';
import ApproveDialog from 'components/FieldTests/ApproveDialog';
import ApproveWJudgementForm from 'components/FieldTests/ApproveWJudgementForm';
import DoneIcon from '@material-ui/icons/Done';
import WarningIcon from '@material-ui/icons/Warning';
import { InspectionAndFieldTestActions } from 'utils/InspectionsUtils';
import FieldTestReviewButtons from 'components/FieldTests/FieldTestReviewButtons';
import { useCanDoAction } from 'hooks/useCanDoAction';

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: 12,
    fontVariant: 'all-small-caps'
  },
  cardHeaderPositive: {
    background: theme.palette.success.main,
    color: theme.palette.success.contrastText
  },
  cardHeaderNegative: {
    background: theme.palette.warning.main,
    color: theme.palette.warning.contrastText
  },
}))

const FieldTestCards = ({ fieldTests, showActions, refresh }) => {
  const [showApproveDialog, setShowApproveDialog] = useState(false);
  const [selectedCardData, setSelectedCardData] = useState(undefined);
  const [selectedAction, setSelectedAction] = useState(undefined);

  const handleAction = (data, event) => {
    setSelectedAction(event.target.textContent);
    setSelectedCardData(data);
    setShowApproveDialog(true);
  };

  const closeDialog = (e) => {
    setShowApproveDialog(false);
    setSelectedCardData(undefined);
  };

  const handleSubmit = () => setTimeout(() => { closeDialog(); refresh() }, 800);

  return (
    <>
      {
        // if the field tests have been fetched, show the field tests, else show a loader
        fieldTests.ready ?
          fieldTests.data.map((r, i) => <FieldTestCard fieldTest={r} key={r.FieldTestId} actionClick={handleAction} showActions={showActions} />) :
          <div style={{ textAlign: 'center' }}><CircularProgress disableShrink /></div>
      }
      {
        // if the field tests have been fetched, are there are no field test, show a card that explains there are no field tests
        fieldTests.ready && fieldTests.data.length === 0 &&
        <Card><CardContent><Typography variant="h6">No field tests found for this inspection</Typography></CardContent></Card>
      }
      <ApproveDialog
        show={showApproveDialog}
        Form={() => <ApproveWJudgementForm rowData={[selectedCardData]} status={selectedAction} submit={handleSubmit} onCancel={closeDialog} />}
      ></ApproveDialog>
    </>
  )
};


const FieldTestCard = ({ fieldTest, actionClick, showActions }) => {
  const classes = useStyles();
  const { SampleCd,FieldTestId, MaterialDesc_FieldMaterial, MaterialCode_FieldMaterial,TestType_Form, Description_ReviewStatus, Description_TestResults,SpecItem_FieldMaterial,MaterialSub_FieldMaterial,Supplier_FieldMaterial } = fieldTest;
  console.log("FieldTestCard", fieldTest);
  const actionsRequired = InspectionAndFieldTestActions.canReviewFT(fieldTest);
  const canUpdate = useCanDoAction('Tests', 'update');

  return (
    <Card style={{ marginTop: 8 }}>
      {actionsRequired ? showActions && <CardHeader avatar={<WarningIcon />} title={"Action Required"} className={classes.cardHeaderNegative}></CardHeader> :
        showActions && <CardHeader avatar={<DoneIcon />} title={"No Action Required"} className={classes.cardHeaderPositive}></CardHeader>}
      <CardContent>
        <Typography color="textSecondary" className={classes.title} gutterBottom>
          Sample ID
        </Typography>
        <Typography gutterBottom>
          {SampleCd}
        </Typography>
        <Typography color="textSecondary" className={classes.title} gutterBottom>
          Materials
        </Typography>
        <Typography gutterBottom>
          {MaterialDesc_FieldMaterial}
        </Typography>
        <Typography color="textSecondary" className={classes.title} gutterBottom>
          Material Code
        </Typography>
        <Typography gutterBottom>
          {MaterialCode_FieldMaterial}
        </Typography>
        <Typography color="textSecondary" className={classes.title} gutterBottom>
          Spec Item
        </Typography>
        <Typography gutterBottom>
          {SpecItem_FieldMaterial}
        </Typography>
        <Typography color="textSecondary" className={classes.title} gutterBottom>
          Supplier
        </Typography>
        <Typography gutterBottom>
          {Supplier_FieldMaterial ? Supplier_FieldMaterial : "N/A"}
        </Typography>
        <Typography color="textSecondary" className={classes.title} gutterBottom>
          Material SubCategory
        </Typography>
        <Typography gutterBottom>
          {MaterialSub_FieldMaterial ? MaterialSub_FieldMaterial : "N/A"}
        </Typography>
        <Typography color="textSecondary" className={classes.title} gutterBottom>
          Test Type
        </Typography>
        <Typography gutterBottom>
          {TestType_Form}
        </Typography>
        <Typography color="textSecondary" gutterBottom className={classes.title}>
          Status
        </Typography>
        <Typography gutterBottom>
          {Description_TestResults}
        </Typography>
        <Typography color="textSecondary" gutterBottom className={classes.title}>
          Review Status
        </Typography>
        <Typography gutterBottom>
          {Description_ReviewStatus ?
            Description_ReviewStatus
            : 
            InspectionAndFieldTestActions.canReviewFT(fieldTest) ? "Review Required" : "No Review Needed"
          }
        </Typography>
      </CardContent>
      <CardActions>
        {actionsRequired && canUpdate &&
          <FieldTestReviewButtons fieldTest={fieldTest}  handleClick={actionClick} />
        }
      </CardActions>
    </Card>
  )
}


export default FieldTestCards;
export { FieldTestCard };